import { useEffect } from 'react'

import useUiStore from '~/hooks/stores/useUiStore'

/**
 * Keeps <html data-theme> / <html data-density> in sync with the persisted UI
 * store. Initial values are applied pre-hydration by the inline script in
 * pages/_document.js (to avoid a flash of the wrong theme); this component keeps
 * them current when the user switches at runtime. Renders nothing.
 */
const UiPreferences = () => {
  const theme = useUiStore.use.theme()
  const density = useUiStore.use.density()

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  useEffect(() => {
    document.documentElement.setAttribute('data-density', density)
  }, [density])

  return null
}

export default UiPreferences
